module.exports = __webpack_public_path__ + "static/media/without-message-figure.5018fa3b.svg";